export default "__VITE_ASSET__CFgZr_ie__"